import { BindAll } from 'lodash-decorators'
import moment from 'moment'

import { observable } from 'mobx'

import {
  counter_stats,
  rfq_win_rate_by_company,
  order_response_time_by_company,
  order_response_time_by_user,
  quote_response_time_by_company,
  quote_response_time_by_user,
} from 'vendor/server/dashboard'

const formatDuration = (input) => {
  const duration = moment.duration(input)

  const months = duration.months()
  const weeks = duration.weeks()
  const days = duration.days()
  const hours = duration.hours()
  const minutes = duration.minutes()

  if (!months && !weeks && !days && !hours && !minutes) {
    return '< 1min'
  }

  if (!!months || !!weeks || !!days) {
    return `${months ? months + 'm ' : ''}${weeks ? weeks + 'w ' : ''}${days ? days + 'd ' : ''}${
      hours ? hours + 'h ' : ''
    }`
  }

  return `${hours ? hours + 'h ' : ''}${minutes ? minutes + 'min' : ''}`
}
@BindAll()
export default class DashboardStore {
  @observable counterStats = {
    orders_count: 0,
    quotes_count: 0,
    customers_count: 0,
    median_order_response_time: '0',
  }
  rfqWinRateByCompany = observable.array([], { deep: true })
  orderResponseTimeByCompany = observable.array([], { deep: true })
  orderResponseTimeByUser = observable.array([], { deep: true })
  quoteResponseTimeByCmpany = observable.array([], { deep: true })
  quoteResponseTimeByUser = observable.array([], { deep: true })

  async getCounterStats(numDays: number) {
    const { data } = await counter_stats(numDays)

    this.counterStats = {
      orders_count: data?.orders_count,
      quotes_count: data?.quotes_count,
      customers_count: data?.customers_count,
      median_order_response_time: formatDuration(data?.median_order_response_time),
    }
  }

  async getRfqWinRateByCompany(numDays: number) {
    const { data } = await rfq_win_rate_by_company(numDays)
    const items = data?.items?.map((item) => ({
      name: item?.name,
      won: item?.won,
      lost: item?.lost,
      total_rfqs: item?.total_rfqs,
      perc_won: Number(item?.perc_won).toFixed(2),
    }))
    this.rfqWinRateByCompany.replace(items || [])
  }

  async getOrderResponseTimeByCompany(numDays: number) {
    const { data } = await order_response_time_by_company(numDays)
    const items = data?.items?.map((item) => ({
      name: item?.customer_name,
      response_time_25: formatDuration(item?.response_time_25),
      response_time_50: formatDuration(item?.response_time_50),
      response_time_75: formatDuration(item?.response_time_75),
      average_response_time: formatDuration(item?.average_response_time),
      num_orders: item?.num_orders,
    }))
    this.orderResponseTimeByCompany.replace(items || [])
  }

  async getOrderResponseTimeByUser(numDays: number) {
    const { data } = await order_response_time_by_user(numDays)
    const items = data?.items?.map((item) => ({
      name: item?.email,
      response_time_25: formatDuration(item?.response_time_25),
      response_time_50: formatDuration(item?.response_time_50),
      response_time_75: formatDuration(item?.response_time_75),
      average_response_time: formatDuration(item?.average_response_time),
      num_orders: item?.num_orders,
    }))
    this.orderResponseTimeByUser.replace(items || [])
  }

  async getQuoteResponseTimeByCmpany(numDays: number) {
    const { data } = await quote_response_time_by_company(numDays)
    const items = data?.items?.map((item) => ({
      name: item?.customer_name,
      response_time_25: formatDuration(item?.response_time_25),
      response_time_50: formatDuration(item?.response_time_50),
      response_time_75: formatDuration(item?.response_time_75),
      average_response_time: formatDuration(item?.average_response_time),
      num_orders: item?.num_orders,
    }))
    this.quoteResponseTimeByCmpany.replace(items || [])
  }

  async getQuoteResponseTimeByUser(numDays: number) {
    const { data } = await quote_response_time_by_user(numDays)
    const items = data?.items?.map((item) => ({
      name: item?.email,
      response_time_25: formatDuration(item?.response_time_25),
      response_time_50: formatDuration(item?.response_time_50),
      response_time_75: formatDuration(item?.response_time_75),
      average_response_time: formatDuration(item?.average_response_time),
      num_orders: item?.num_orders,
    }))
    this.quoteResponseTimeByUser.replace(items || [])
  }
}
